export const PUBLISHING_FONT_OPTIONS = [
  'Abril Fatface', 'Anton', 'Archivo', 'Barlow', 'Bebas Neue', 'Bitter', 'Cabin', 'Cairo', 'Comfortaa',
  'Crimson Pro', 'DM Sans', 'Domine', 'Exo 2', 'Fira Sans', 'Fraunces', 'Hind', 'IBM Plex Sans',
  'Inconsolata', 'Inter', 'Josefin Sans', 'Kanit', 'Karla', 'Lato', 'Lexend', 'Libre Baskerville',
  'Manrope', 'Merriweather', 'Montserrat', 'Mulish', 'Nunito', 'Open Sans', 'Oswald', 'Outfit',
  'Playfair Display', 'Poppins', 'PT Sans', 'Quicksand', 'Raleway', 'Roboto', 'Roboto Slab', 'Rubik',
  'Source Sans 3', 'Space Grotesk', 'Ubuntu', 'Work Sans',
];

export const PUBLISHING_GRADIENTS = [
  { id: 'ocean', name: 'Ocean Blue', colors: ['#0f56c5', '#1d4ed8', '#312e81'] },
  { id: 'sunset', name: 'Sunset', colors: ['#f97316', '#ec4899', '#7c3aed'] },
  { id: 'violet', name: 'Electric Violet', colors: ['#7c3aed', '#4f46e5', '#2563eb'] },
  { id: 'emerald', name: 'Emerald Forest', colors: ['#10b981', '#059669', '#0f766e'] },
  { id: 'midnight', name: 'Midnight Sky', colors: ['#0f172a', '#1e1b4b', '#4338ca'] },
  { id: 'candy', name: 'Candy Pink', colors: ['#fb7185', '#ec4899', '#8b5cf6'] },
  { id: 'fire', name: 'Fire & Gold', colors: ['#dc2626', '#f97316', '#f59e0b'] },
  { id: 'aqua', name: 'Aqua Wave', colors: ['#0891b2', '#0ea5e9', '#6366f1'] },
  { id: 'lime', name: 'Lime Fresh', colors: ['#65a30d', '#16a34a', '#059669'] },
  { id: 'royal', name: 'Royal Purple', colors: ['#1d4ed8', '#4f46e5', '#7e22ce'] },
];

export const PUBLISHING_FONTS_URL = `https://fonts.googleapis.com/css2?${PUBLISHING_FONT_OPTIONS.map((font) => `family=${font.replace(/ /g, '+')}`).join('&')}&display=swap`;
